export function buildLoginRedirectUrl(redirectUrl) {
  const destination = redirectUrl !== null && redirectUrl !== void 0 ? redirectUrl : `${window.location.origin}${window.location.pathname}${window.location.search}`;
  return `/_hcms/mem/login?redirect_url=${encodeURIComponent(destination)}`;
}
export function redirectToLogin(redirectUrl) {
  window.location.href = buildLoginRedirectUrl(redirectUrl);
}